import { cloneDeep, orderBy, sortBy } from 'lodash';

import store from '../state/store';
import { Actions } from '../state/project/actions';
import { Project } from '../state/project/types';
import { ProjectSortTypes } from '../enums/ProjectSortTypes';

export const projectListSorter = (projects: Project[], sortDirection?: 'asc' | 'desc', sortType?: ProjectSortTypes, search?: string) => {
  let newProjectList = cloneDeep(projects);

  if (search && search.length > 2) {
    // Filter by search term and sort by priority
    newProjectList = sortBy(
      newProjectList.filter((pro) =>
        [pro.constructionArea, pro.name, pro.code].some((item) => String(item).toLowerCase().includes(search.toLowerCase()))
      ),
      (item) => item.name.toLowerCase().includes(search.toLowerCase()),
      (item) => item.code.toLowerCase().includes(search.toLowerCase()),
      (item) => item.constructionArea.toLowerCase().includes(search.toLowerCase())
    ).reverse();
  }

  switch (sortType) {
    case ProjectSortTypes.Name:
      newProjectList = orderBy(newProjectList, (project) => [project.name.toLowerCase()], [sortDirection || 'desc']);
      break;
    case ProjectSortTypes.ProjectNumber:
      newProjectList = orderBy(newProjectList, (project) => [project.code.replace('-', '')], [sortDirection || 'desc']);
      break;
    case ProjectSortTypes.ConstructionArea:
      newProjectList = orderBy(newProjectList, (project) => [project.constructionArea.toLowerCase()], [sortDirection || 'desc']);
      break;
    case ProjectSortTypes.LastBooking:
      newProjectList = orderBy(newProjectList, (project) => [project.lastBooking ? project.lastBooking.toLowerCase() : ''], [
        sortDirection || 'desc'
      ]);
      break;
    default:
      store.dispatch(Actions.setProjects(newProjectList));
  }
  store.dispatch(Actions.setProjects(newProjectList));
};
